/**
 * @author jakubbujakowski
 * @since 2020-12-1
 */
import * as React from "react";
import { Helmet } from "react-helmet";

import { SmallHeading } from "@ui/Atoms/Headings";

import { Section, Paragraph, OptionPanel } from "@ui/Atoms";

interface Props {
  htmlMetaTitleText: string;
  titleText: string;
  bodyText: string | React.ReactElement;
}

export const NotFound = (props: Props): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>{props.htmlMetaTitleText}</title>
    </Helmet>
    <Section small>
      <OptionPanel>
        <SmallHeading>{props.titleText}</SmallHeading>
        <Paragraph>{props.bodyText}</Paragraph>
      </OptionPanel>
    </Section>
  </React.Fragment>
);

NotFound.displayName = "NotFound";
